import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [{
        path: "/",
        component: (resolve) =>
            require(["@/P09_BaiCaiHui/components/Home.vue"], resolve),
        children: [{
                //首页
                path: "/",
                name: "/",
                component: (resolve) =>
                    require(["@/P09_BaiCaiHui/components/Center.vue"], resolve),
            },
            {
                //二级页面
                path: "/up",
                component: (resolve) =>
                    require(["@/P09_BaiCaiHui/views/up.vue"], resolve),
                children: [

                ],
            },
            //百才汇 联系我们
            {
                path: "/lianxiwomen.:html",
                name: 'lianxiwomen',
                component: (resolve) =>
                    require(["@/P09_BaiCaiHui/views/Pages/lianxiwomen"], resolve),
            },
            //百才汇 居转户
            {
                path: "/juzhuanhu.:html",
                name: 'juzhuanhu',
                component: (resolve) =>
                    require(["@/P09_BaiCaiHui/views/Pages/juzhuanhu"], resolve),
            },
            //百才汇 政策中心
            {
                path: "/zhengcezhongxin.:html",
                name: 'zhengcezhongxin',
                component: (resolve) =>
                    require(["@/P09_BaiCaiHui/views/Pages/zhengcezhongxin"], resolve),
            },
            //百才汇  留学生落户页面
            {
                path: "/liuxueshengluohu.:html",
                name: 'liuxueshengluohu',
                component: (resolve) =>
                    require([
                        "@/P09_BaiCaiHui/views/Pages/liuxueshengluohu.vue",
                    ], resolve),
            },
            //百才汇  海归名企实业
            {
                path: "/faovrt.:html",
                name: 'faovrt',
                component: (resolve) =>
                    require([
                        "@/P09_BaiCaiHui/views/Pages/zdl/famousOverseasReturnees.vue",
                    ], resolve),
            },
            //百才汇  人才引进
            {
                path: "/talenti.:html",
                name: 'talenti',
                component: (resolve) =>
                    require([
                        "@/P09_BaiCaiHui/views/Pages/zdl/talentIntroduction.vue",
                    ], resolve),
            },
            //百才汇  要闻动态 常见问答
            {
                path: "/changjianwenda/:id.:html",
                name: 'changjianwenda',
                component: (resolve) =>
                    require([
                        "@/P09_BaiCaiHui/views/Pages/yaowendongtaiFile/changjianwenda.vue",
                    ], resolve),
            },
            {
                path: "/changjianwenda.:html",
                name: 'changjianwenda',
                redirect: "/changjianwenda/1.:html",
            },
            //百才汇  要闻动态 常见问答详情页
            {
                path: '/wendacontent/:id-:WebsiteMenuId.:html',
                name: 'wendacontent',
                component: resolve => require([
                    "@/P09_BaiCaiHui/views/Pages/yaowendongtaiFile/wendacontent.vue",
                ], resolve),
            },
            //百才汇  落户政策
            {
                path: "/luohuzhengce/:id.:html",
                name: 'luohuzhengce',
                component: (resolve) =>
                    require([
                        "@/P09_BaiCaiHui/views/Pages/zhengce",
                    ], resolve),
            },
            {
                path: "/luohuzhengce.:html",
                name: 'luohuzhengces',
                redirect: "/luohuzhengce/1.:html",
            },
            //百才汇  落户政策详情页详情页
            {
                path: "/luohuxiangqing/:id.:html",
                name: 'luohuxiangqing',
                component: (resolve) =>
                    require([
                        "@/P09_BaiCaiHui/views/Pages/zhengce/xiangqing.vue",
                    ], resolve),
            },
        ],
    },
    //404页面路由配置
    {
        name: "404",
        path: "*",
        component: (resolve) =>
            require(["@/P09_BaiCaiHui/components/notfount.vue"], resolve),
    },
    // {
    //     path: "*",
    //     redirect: {
    //         name: "/",
    //     },
    // },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
// 动态切换title
// const _title = {
//   head_University: '我的名片',
//   MyApp: '联系我们',
//   qingxi: '联系我们',
//   hanliu: '联系我们',
//   home:'首页'
// }
// router.beforeEach((to, form,next) => {
//   window.document.title = _title[to.name];
//   next();
// })
export default router;